<template>
  <div>
    <searchedContents :contents="types" :localLang="localLang"></searchedContents>
  </div>
</template>

<script>
export default {
  props: ["types", "localLang"],
  data() {
    return {};
  },
  created() {
    
  },
  components: {
    searchedContents: () =>
      import(
        /* webpackChunkName: "searchedContents" */ "./SearchedContentsCarousel.vue"
      )
  }
};
</script>

<style lang="scss" scoped>
</style>